import React, { useEffect, useState } from "react";
import "./OrdersView.css";
import { toast } from "react-toastify";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment-timezone";
import { Button, Form, Table } from "react-bootstrap";
import { Dialog, DialogContent, DialogTitle, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LoadingSpinner from "../../Loading/component";
import profile from "../../../assests/gprofile.svg";
import Avatar from "../../../assests/Avatar.png";
import infoIcon from "../../../assests/infoIcon.svg";
import phone1 from "../../../assests/phone11.svg";
import mail from "../../../assests/mail.svg";
import dateTime from "../../../assests/dateTime.svg";
import city from "../../../assests/city.svg";
import kiosk from "../../../assests/kiosk.svg";
import vm from "../../../assests/vm.svg";
import leftArrow from "../../../assests/leftArrow.svg";
import itemDetails from "../../../assests/itemDetails.svg";
import refund from "../../../assests/refund.svg";
import success from "../../../assests/success.svg";
import cross from "../../../assests/cross.svg";
import panding from "../../../assests/panding.svg";
import cancel from "../../../assests/cancel.svg";
import upi from "../../../assests/upi.svg";
import indicator from "../../../assests/indictor.svg";
import refundNotreq from "../../../assests/refundNotreq.svg";
import emptyCircleIcon from "../../../assests/emptyCircleIcon.svg";
import refund_upon from "../../../assests/refund_upon.svg";
import refundschdulesuccess from "../../../assests/refundschdulesuccess.svg";
import notrequired from "../../../assests/notrequired.svg";
import refund_success from "../../../assests/refund_success.svg";
import failedrefundicon from "../../../assests/failedrefundicon.svg";
import checkIconGreen from "../../../assests/checkIconGreen.svg";
import walletIcon from "../../../assests/walletIcon.svg";
import bankcard from "../../../assests/bankcard.svg";

const statusConfig = {
  REFUND_UPON_REQUEST: {
    icon: refund_upon,
    color: "#F28618",
    message: "If the customer did not receive any product, verify and initiate a manual refund.",
    successMSG: "Refund will be processed to your payment source"
  },
  REFUND_SCHEDULED: {
    icon: refundschdulesuccess,
    color: "#14AE78",
    message: "Your refund has been successfully scheduled and will be initiated in 40mins.",
    successMSG: "Refund will be processed to your payment source."
  },
  REFUND_SUCCESSFUL: {
    icon: refund_success,
    color: "#14AE78",
    message: "Refund reference number is 12345678",
    successMSG: "Refund successfully credited to your payment source."
  },
  REFUND_INITIATION_FAILED: {
    icon: notrequired,
    color: "#DC3545",
    message: "Kindly refund manually or ask admin to refund by a payment gateway dashboards.",
    successMSG: "Refund will be processed to your payment source.",
  },
  REFUND_NOT_REQUIRED: {
    icon: refundNotreq,
    color: "#DC3545",
    message: "If customer has any concern, kindly ask for product image and then initiate manual refund.",
    successMSG: "Refund will be processed to your payment source.",
  },
  REFUND_INITIATED: {
    icon: checkIconGreen,
    color: "#DC3545",
    message: "If customer has any concern, kindly ask for product image and then initiate manual refund.",
    successMSG: "Refund will be processed to your payment source.",
  },
  REFUND_FAILED: {
    icon: failedrefundicon,
    color: "#DC3545",
    message: "Refund could not be processed due to a technical issue.",
    successMSG: "Refund will be processed to your payment source.",
  },
};

export const OrdersViewComp = ({
  data,
  loading,
  show = false,
  handleClose = () => {},
  handleShow = () => {},
  handleSubmit = () => {},
  issue = "",
  handleIssueChange = () => {},
  selectedIssue = "",
  handleIssueTextChange = () => {},
  handleCopyInfo = () => {},
  orderStatus = null,
  fetchOrderStatus = () => {},
}) => {
  const refundDetails = orderStatus || [];
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0);
  const navigate = useNavigate();
  const { orderid, pg_name } = useParams();

  const handleOpenStatusModal = () => {
    setShowStatusModal(true);
    if (fetchOrderStatus) fetchOrderStatus();
  };

  const handleCloseStatusModal = () => setShowStatusModal(false);

  useEffect(() => {
    if (data?.created_at) {
      const createdTime = moment(data.created_at);
      const currentTime = moment();
      const maxAllowedTimeInSeconds = 35 * 60;
      const timeDifferenceInSeconds = currentTime.diff(createdTime, "seconds");
      const remainingTimeInSeconds = maxAllowedTimeInSeconds - timeDifferenceInSeconds;

      if (remainingTimeInSeconds > 0) {
        setRemainingTime(remainingTimeInSeconds);
        const timer = setInterval(() => setRemainingTime(prev => prev - 1), 1000);
        return () => clearInterval(timer);
      }
    }
  }, [data]);

  const arrowClick = () => navigate("/home/ordersview");

  const handleInitiateRefund = () => {
    const pg_name = data?.payment_details?.pg_name !== "null" ? data?.payment_details?.pg_name : "";
    const id = data?.id;
    const source = data?.source;

    if (!pg_name || !id || !source) {
      toast.error("Refund cannot be initiated. Required information is missing!");
      return;
    }
    navigate(`/home/orderview/manualrefund/${pg_name}/${id}/${source}`);
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="ov-main-container">
      <Sidebar />
      
      <div className="ov-content">
        {/* Header */}
        <div className="ov-header">
          <button onClick={arrowClick} className="ov-back-btn">
            <img src={leftArrow} alt="Back" />
          </button>
          <div className="ov-order-details">
            <h1 className="ov-mini-order-id">Mini Order ID: {data?.dcCode || "N/A"}</h1>
            <h5 className="ov-order-id">Order ID: {data?.id || "N/A"}</h5>
          </div>
          <div className="ov-status-badge">
            <span>{data?.status || "N/A"}</span>
          </div>
          <div className="ov-action-buttons">
            <button className="ov-btn ov-btn-primary" onClick={handleShow}>
              Copy Details
            </button>
            <button className="ov-btn ov-btn-success" onClick={handleInitiateRefund}>
              Initiate Refund
            </button>
          </div>
        </div>

        {/* Two Column Layout */}
        <div className="ov-two-column">
          {/* Customer Details */}
          <div className="ov-card">
            <div className="ov-card-header">
              <img src={profile} alt="" className="ov-card-icon" />
              <p>Customer Details</p>
            </div>
            <div className="ov-customer-card">
              <div className="ov-customer-avatar">
                <img src={Avatar} alt="Customer" />
                <p>{data?.user_details?.name || "N/A"}</p>
              </div>
              <div className="ov-customer-info">
                <div className="ov-info-row">
                  <img src={phone1} alt="" />
                  <p>{data?.phone || "N/A"}</p>
                </div>
                <div className="ov-info-row">
                  <img src={mail} alt="" />
                  <p>{data?.user_details?.email || "N/A"}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Order Information */}
          <div className="ov-card">
            <div className="ov-card-header ov-card-header-with-btn">
              <div className="ov-card-header-left">
                <img src={infoIcon} alt="" className="ov-card-icon" />
                <p>Order Information</p>
              </div>
              <button className="ov-btn-small ov-btn-small-primary" onClick={handleCopyInfo}>
                Copy Info
              </button>
            </div>
            <div className="ov-card-body">
              <div className="ov-info-row">
                <img src={dateTime} alt="" />
                <p>Date & Time: {data?.created_at ? moment.utc(data.created_at).tz("Asia/Kolkata").format("YYYY-MM-DD hh:mm:ss A") : "N/A"}</p>
              </div>
              <div className="ov-info-row">
                <img src={city} alt="" />
                <p>City: {data?.city || "N/A"}</p>
              </div>
              <div className="ov-info-row">
                <img src={city} alt="" />
                <p>VM Address: {data?.vmAddress || "N/A"}</p>
              </div>
              <div className="ov-info-row">
                <img src={kiosk} alt="" />
                <p>Order Via: {data?.source || "N/A"}</p>
              </div>
              <div className="ov-info-row">
                <img src={vm} alt="" />
                <p>VM Name: {data?.name || "N/A"}</p>
              </div>
              <div className="ov-info-row">
                <img src={vm} alt="" />
                <p>VM ID: {data?.machine_id || "N/A"}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Items Details */}
        <div className="ov-card ov-items-card">
          <div className="ov-card-header">
            <img src={itemDetails} alt="" className="ov-card-icon" />
            <p>Items Details</p>
          </div>
          <div className="ov-table-wrapper">
            <Table responsive className="ov-table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Slot Number</th>
                  <th>MRP</th>
                  <th>Offer Price</th>
                  <th>Quantity</th>
                  <th>Total</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data?.line_items?.length > 0 ? (
                  data.line_items.map((item) => (
                    <tr key={item.id}>
                      <td>{item.name || "N/A"}</td>
                      <td>{item.slot_id || "N/A"}</td>
                      <td>₹ {item.mrp || 0}</td>
                      <td>₹ {item.offer_price || 0}</td>
                      <td>{item.item_count || 0}</td>
                      <td>₹ {item.sub_total || 0}</td>
                      <td>
                        {item.success_count > 0 && <span className="ov-status-success">{item.success_count} ✓</span>}
                        {item.failure_count > 0 && <span className="ov-status-failure">{item.failure_count} ✗</span>}
                        {item.vend_remaining_count > 0 && <span className="ov-status-pending">{item.vend_remaining_count} ⏳</span>}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="7" className="ov-no-data">No items found</td></tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        {/* Payment Details */}
        <div className="ov-card ov-payment-card">
          <div className="ov-card-header ov-card-header-with-btn">
            <div className="ov-card-header-left">
              <img src={refund} alt="" className="ov-card-icon" />
              <p>Payment Details</p>
            </div>
            <button className="ov-btn-small ov-btn-small-outline" onClick={handleOpenStatusModal}>
              Check Refund Status
            </button>
          </div>
          <div className="ov-payment-body">
            <h3 className="ov-payment-amount">₹ {data?.amount || 0}</h3>
            <div className="ov-payment-grid">
              <div className="ov-payment-item">
                <p className="ov-payment-label">ID</p>
                <p className="ov-payment-value">{data?.payment_details?.id || "N/A"}</p>
              </div>
              <div className="ov-payment-item">
                <p className="ov-payment-label">Status</p>
                <p className="ov-payment-value">{data?.payment_details?.status || "N/A"}</p>
              </div>
              <div className="ov-payment-item">
                <p className="ov-payment-label">Date & Time</p>
                <p className="ov-payment-value">
                  {data?.payment_details?.updated_at ? moment.utc(data.payment_details.updated_at).tz("Asia/Kolkata").format("YYYY-MM-DD hh:mm:ss A") : "N/A"}
                </p>
              </div>
              <div className="ov-payment-item">
                <p className="ov-payment-label">Gateway</p>
                <p className="ov-payment-value">{data?.payment_details?.pg_name || "N/A"}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Custom Attractive Modal Popup */}
        {show && (
          <div className="ov-modal-overlay" onClick={handleClose}>
            <div className="ov-modal-container" onClick={(e) => e.stopPropagation()}>
              <div className="ov-modal-header">
                <div className="ov-modal-header-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V8L16 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                    <path d="M16 3V8H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 16L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <path d="M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </div>
                <h3 className="ov-modal-title">Copy Order Details</h3>
                <button className="ov-modal-close" onClick={handleClose}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M18 6L6 18M6 6L18 18" />
                  </svg>
                </button>
              </div>
              <div className="ov-modal-body">
                <Form>
                  <div className="ov-form-group">
                    <label className="ov-form-label">Customer Issues</label>
                    <select 
                      className="ov-form-select" 
                      value={selectedIssue} 
                      onChange={handleIssueChange}
                    >
                      <option value="">-- Select an issue --</option>
                      <option value="Vending Failed">Vending Failed</option>
                      <option value="Product got stuck">Product got stuck</option>
                      <option value="other">Other</option>
                    </select>
                    {selectedIssue === "other" && (
                      <textarea
                        className="ov-form-textarea"
                        rows="4"
                        value={issue}
                        onChange={handleIssueTextChange}
                        placeholder="Please describe the issue in detail..."
                      />
                    )}
                  </div>
                </Form>
              </div>
              <div className="ov-modal-footer">
                <button className="ov-modal-btn ov-modal-btn-secondary" onClick={handleClose}>
                  Cancel
                </button>
                <button className="ov-modal-btn ov-modal-btn-primary" onClick={handleSubmit}>
                  Copy Details
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Refund Status Dialog */}
        <Dialog open={showStatusModal} onClose={handleCloseStatusModal} maxWidth="md" fullWidth className="ov-refund-dialog">
          <DialogTitle className="ov-refund-dialog-header">
            Refund Status
            <IconButton onClick={handleCloseStatusModal} className="ov-refund-dialog-close">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className="ov-refund-dialog-content">
            {refundDetails?.refundDetailInfoList?.length > 0 ? (
              refundDetails.refundDetailInfoList.map((refund, index) => {
                const isStepperView = ["REFUND_INITIATED", "REFUND_SUCCESSFUL"].includes(refund.status);
                const status = statusConfig[refund.status] || statusConfig.REFUND_UPON_REQUEST;

                return (
                  <div className="ov-refund-card" key={index}>
                    <p className="ov-refund-order-id">Order ID: <span>{refundDetails.orderId || "N/A"}</span></p>
                    {isStepperView ? (
                      <div className="ov-refund-stepper">
                        <div className="ov-refund-step">
                          <img src={checkIconGreen} alt="" />
                          <div>
                            <p className="ov-refund-step-title">Refund Initiated</p>
                            <p className="ov-refund-step-time">{refund.refundInitiatedTime ? moment.utc(refund.refundInitiatedTime).local().format("D MMM YYYY, h:mm A") : "N/A"}</p>
                          </div>
                        </div>
                        <div className="ov-refund-step">
                          <img src={refund.status === "REFUND_SUCCESSFUL" ? checkIconGreen : emptyCircleIcon} alt="" />
                          <div>
                            {refund.status === "REFUND_SUCCESSFUL" ? (
                              <>
                                <p className="ov-refund-step-title ov-success">Refund Successful</p>
                                <p className="ov-refund-step-time ov-success">{refund.refundCreditTime ? moment.utc(refund.refundCreditTime).local().format("D MMM YYYY, h:mm A") : "N/A"}</p>
                              </>
                            ) : (
                              <>
                                <p className="ov-refund-step-title">Refund Processing By Bank</p>
                                <p className="ov-refund-step-time">Expected settlement: {refund.refundCreditExpectedTime ? moment.utc(refund.refundCreditExpectedTime).local().format("D MMM YYYY, h:mm A") : "Refund initiation + 60 min"}</p>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="ov-refund-status-view">
                        <div className="ov-refund-status-icon">
                          <img src={status.icon} alt="" />
                        </div>
                        <p className="ov-refund-status-text" style={{ color: status.color }}>{refund.status?.replaceAll("_", " ") || "N/A"}</p>
                        <p className="ov-refund-status-message">{status.message}</p>
                      </div>
                    )}
                    <div className="ov-refund-info-card">
                      <p className="ov-refund-info-text">Paid Amount: <span>₹ {refund.paidAmount || "0"}</span></p>
                      <p className="ov-refund-info-subtext">{refund.paymentTime ? moment.utc(refund.paymentTime).local().format("MMM D, YYYY, h:mm A") : "N/A"}</p>
                      <p className="ov-refund-info-subtext">Transaction ID: {refund.transactionId || "N/A"}</p>
                      <hr className="ov-refund-divider" />
                      {refund.status !== "REFUND_NOT_REQUIRED" && (
                        <>
                          <p className="ov-refund-info-text">{refund.status === "REFUND_FAILED" ? "Refund Failed Amount" : "Refund Amount"}: <span>₹ {refund.refundAmount || "0"}</span></p>
                          <hr className="ov-refund-divider" />
                        </>
                      )}
                      {!["REFUND_INITIATION_FAILED", "REFUND_FAILED", "REFUND_NOT_REQUIRED"].includes(refund.status) && (
                        <>
                          <p className="ov-refund-info-text">Payment Method: <img src={refund.payMethod?.toLowerCase() === "upi" ? upi : refund.payMethod?.toLowerCase() === "wallet" ? walletIcon : bankcard} alt="" className="ov-refund-payment-icon" /> {refund.payMethod ? refund.payMethod.toUpperCase() : "N/A"}</p>
                          <p className="ov-refund-info-subtext">{status.successMSG}</p>
                        </>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="ov-refund-no-data">No refund details available.</p>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};